export const QUERY_PAYEE = "QUERY_PAYEE";
export const QUERY_PAYEES_LIST = "QUERY_PAYEES_LIST";
